import { render, staticRenderFns } from "./MilitaryDetail.vue?vue&type=template&id=571d0a9a"
import script from "./MilitaryDetail.vue?vue&type=script&lang=js"
export * from "./MilitaryDetail.vue?vue&type=script&lang=js"
import style0 from "./MilitaryDetail.vue?vue&type=style&index=0&id=571d0a9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports